import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppService } from '../app.service';
import { state2 } from '../state';
import { defaultCacheTime, INotitieDb } from '../offline/cobradb';
import { tap } from 'rxjs/operators';

export interface INotitie {
  Id: number;
  Inhoud: string;
  AgendapuntId: number;
  Eigenaar: string;
  DatumUpdate: string | Date;
}

export interface IReageerNotitie {
  Notitie: INotitie;
  NotitieToegangen: number[];
}

export interface IReageerNotitieData {
  Partijen: IPartij[];
  ReageerNotitie: IReageerNotitie;
}

export interface IPartij {
  Id: number;
  Naam: string;
  isSelected?: boolean;
  Leden: IPersoon[];
}

export interface IPersoon {
  Id: number;
  Naam: string;
  isSelected?: boolean;
}

export interface INieuweNotitie {
  Id?: number;
  AgendapuntId: number;
  NotitieContent: string;
  PersoonIds: number[];
}


@Injectable({
  providedIn: 'root' // provide in root, made available through application, should be listed in any module
})
export class NotitiesCommonService {

  constructor(private appService: AppService, private http: HttpClient) { }

  getRecenteNotities(page: number, allowFromCache: boolean) {
    const url = this.appService.getUrl(`api/notitie/getrecentenotities?page=${page}`);
    // return state2.getValueOrDefault('recentenotities', this.http.get<INotitieDb[]>(url), defaultCacheTime);
    return state2.getSearchResultOrDefault('recentenotities', this.http.get<INotitieDb[]>(url), { concat: page !== 0, pageSize: 10, page, allowFromCache });
  }

  setNotitieGelezen(notitieToegangId: number) {
    const url = this.appService.getUrl(`api/notitie/setnotitiegelezen?notitieToegangId=${notitieToegangId}`);
    return this.http.post(url, {}).pipe(tap(_ => state2.remove('recentenotities')));
  }

  toevoegenNotitie(notitieModel: INieuweNotitie) {
    const url = this.appService.getUrl('api/notitie/toevoegennotitie');
    return this.http.post<boolean>(url, notitieModel).pipe(
      tap(_ => state2.removeSubKey('detailagendapuntdata', notitieModel.AgendapuntId))
    );
  }

  updateNotitie(notitieModel: INieuweNotitie) {
    const url = this.appService.getUrl('api/notitie/updateNotitie');
    return this.http.post<boolean>(url, notitieModel).pipe(
      tap(_ => state2.removeSubKey('detailagendapuntdata', notitieModel.AgendapuntId))
    );
  }
  verwijderNotitie(notitieId: number) {
    const url = this.appService.getUrl(`api/Notitie/VerwijderNotitie/${notitieId}`);
    return this.http.post<boolean>(url, {}).pipe(
      tap(_ => state2.remove('recentenotities'))
    );
  }

}
